import React, { useEffect, useState, useCallback } from "react";
import { VisibilityIcon, VisibilityOffIcon } from '../../data/icons';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { url } from "../../data/url";

const StudentSignIn = ({ handleServerError, handleForgotPasswordClick }) => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserData = useCallback(async () => {
    try {
      const response = await axios.get(`${url.path}/user/select-company`, { withCredentials: true });
      setUserData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        if (window.location.pathname !== '/signin') {
          navigate('/signin');
        }
      }
      console.error('Error fetching user data:', error);
    }
  }, [navigate]);

  // useEffect(() => {
  //   fetchUserData();
  // }, [fetchUserData]);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    userType: "jobSeeker",
    forgetPassword: false,
  });
  const [formErrors, setFormErrors] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: '',
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  axios.defaults.withCredentials = true;

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleServerError("");
    if (validateForm()) {
      setIsLoading(true);
      try {
        const response = await axios.post(`${url.path}/signin`, formData, {
          withCredentials: true
        });

        const data = response.data;

        if (response.status === 200) {
          // console.log('Signin successful:', data.message);
          resetForm();
          // Fetch user data immediately after successful sign-in
          await fetchUserData();
          // Now use the updated userData to determine navigation
          if (userData && userData.companySelected === null) {
            navigate("/user/experience");
          } else {
            navigate('/user/training-room');
          }
        } else {
          // console.log('Signin unsuccessful:', data.message);
          handleServerError(data.message || "An error occurred during signin");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          handleServerError('Invalid credentials');
        } else if (error.response && error.response.status === 404) {
          handleServerError('Email does not exist, redirect to signup');
        } else {
          console.error('Error during signin:', error);
          handleServerError('An error occurred. Please try again later.');
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log('Form contains errors. Cannot submit.');
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (!formData.email.includes('@')) {
      errors.email = 'Invalid email format';
      valid = false;
    }
    
    setFormErrors(errors);
    return valid;
  };

  const resetForm = () => {
    setFormData({
      email: '',
      password: '',
      userType: "jobSeeker",
      forgetPassword: false,
    });
    setFormErrors({
      email: '',
      password: '',
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="input-group">
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        {formErrors.email && <span className="error">{formErrors.email}</span>}
      </div>
      <div className="input-group">
        <div className="password-group">
          <div className="password-group-container">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span 
              className="visibility-icon" 
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>
          {formErrors.password && <span className="error">{formErrors.password}</span>}
        </div>
      </div>
      <button type="submit" disabled={isLoading}>
        {isLoading ? 'Signing In...' : 'Sign In'}
      </button>
    </form>
  );
};

export default StudentSignIn;